import React from 'react';
import * as R from 'ramda';
import { ChevronDown } from '@goeuro/app/client/frontend-components/src/Icons2/ChevronDown';

import * as Styled from './FooterAccordion.styled';

const fallbackHeight = 200;

const FooterAccordion = ({
  header,
  children,
}: {
  header: React.ReactNode;
  children?: React.ReactNode;
}) => {
  const contentEl = React.useRef(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  const height = R.pathOr(
    fallbackHeight,
    ['current', 'offsetHeight'],
    contentEl
  );

  return (
    <Styled.Container>
      <Styled.Header>
        <Styled.Title>{header}</Styled.Title>
        <Styled.Button onClick={handleClick} isOpen={isOpen}>
          <ChevronDown width={16} height={16} />
        </Styled.Button>
      </Styled.Header>
      <Styled.Content isOpen={isOpen} height={height}>
        <div ref={contentEl}>{children}</div>
      </Styled.Content>
    </Styled.Container>
  );
};

export default FooterAccordion;
